import { PayloadAction, createSlice } from "@reduxjs/toolkit"
import { Pagination } from "../../../types/Pagination"
import { RootState } from "../../app/store"

export interface FaqsState {
  pagination: Pagination
  query: string
}

const initialState: FaqsState = {
  pagination: {
    page: 0,
    size: 10,
  },
  query: "",
}

export const faqsSlice = createSlice({
  name: "faqs",
  initialState,
  reducers: {
    setFaqsPagination: (state, action: PayloadAction<Pagination>) => {
      state.pagination = {
        ...state.pagination,
        ...action.payload,
      }
    },
    setFaqsQuery: (state, action: PayloadAction<string>) => {
      state.query = action.payload
    },
  },
})
export const selectFaqsPagination = (state: RootState) =>
  state.faqs.pagination
export const selectFaqsQuery = (state: RootState) =>
  state.faqs.query
export const { setFaqsPagination, setFaqsQuery } =
  faqsSlice.actions
export default faqsSlice.reducer
